module.exports = __webpack_public_path__ + "img/estatusPendiente.8c8de3f4.png";